/* eslint key-spacing: 'off', comma-spacing: 'off' */
//import VariableGroup from '@/bo/VariableGroup';

export default function VariableGroup (id, title, variables, years) {
  this.id = id === undefined ? null : id;
  this.title = title === undefined ? null : title;
  this.variables = variables === undefined || variables === null ? [] : variables;
  this.years = years === undefined ? null : years;
}
VariableGroup.copy = function (group) {
  return new VariableGroup(group.id, group.title, group.variables, group.years);
};

VariableGroup.createFromVariableGroup = function (g) {
  return new VariableGroup(g.id, g.title, g.variables, g.years);
};
//VariableGroup.nullGroup = function () {
//  return {}
//  return new VariableSelection(new VariableObject('location', 'Location'),
//    'location', new VariableGroup(), /*include=*/true);
//};
